const RELOAD_DELAY = 500;

const attachReloadOnClick = (el) => {
  if (!el) return;

  el.addEventListener('click', () => {
    setTimeout(() => {
      window.location.reload();
    }, RELOAD_DELAY);
  });
};

function cookieBannerInit() {
  elementReady('.pd-cookie-banner-window').then((element) => {
    applyEvent(element);

    const acceptButton = element?.querySelector('.cc-btn.cc-btn-decision.cc-allow'),
      otherAcceptButton = document.querySelector('.pd-cp-btn.pd-cp-ui-save'),
      acceptAll = document.querySelector('.pd-cp-ui-acceptAll');

    attachReloadOnClick(acceptButton);
    attachReloadOnClick(otherAcceptButton);
    attachReloadOnClick(acceptAll);
  });
}

function elementReady(selector) {
  return new Promise((resolve) => {
    const el = document.querySelector(selector);
    if (el) {
      resolve(el);
      return;
    }
    new MutationObserver((mutationRecords, observer) => {
      Array.from(document.querySelectorAll(selector)).forEach((element) => {
        resolve(element);
        observer.disconnect();
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
}

function applyEvent(element) {
  if (!element) return;

  const target = document.querySelector('.cc-message');
  const modalContainer = document.querySelector('#cookie-banner-modal-container');
  const modalText = document.querySelector('#cookie-modal-text-container');
  const modal = document.querySelector('#cookie-banner-modal');
  const crossBtn = modal.querySelector('.cross-btn');
  const buttons = document.querySelector('.cc-compliance.cc-highlight');

  target.addEventListener('click', (e) => {
    e.preventDefault();

    if (modalText && modalText.dataset.url) {
      fetch(`${modalText.dataset.url}.json`)
        .then((response) => response.json())
        .then((data) => {
          modalText.innerHTML = data?.policy?.body;
        })
        .catch((error) => {
          console.error('Error fetching privacy policy:', error);
        });
    }

    if (modalContainer.ariaHidden === 'true') {
      modalContainer.setAttribute('aria-hidden', 'false');
    } else {
      modalContainer.setAttribute('aria-hidden', 'true');
    }
  });
  crossBtn.addEventListener('click', () => {
    modalContainer.setAttribute('aria-hidden', 'true');
    modalText.innerHTML = '';
  });
  modalContainer.addEventListener('click', (e) => {
    if (e.target !== modalContainer) return;
    modalContainer.setAttribute('aria-hidden', 'true');
  });
  buttons.addEventListener('click', () => {
    modalContainer.setAttribute('aria-hidden', 'true');
  });
}

if (document.status === 'loading') {
  document.addEventListener('DOMContentLoaded', cookieBannerInit);
} else {
  cookieBannerInit();
}
